<script setup lang="ts">
import type { EditorialStripAnchorsProps } from './EditorialStripAnchors.props'
import type { EditorialStripAnchorsItemProps } from './EditorialStripAnchorsItem.props'

const props = defineProps<EditorialStripAnchorsProps>()

const { dispatchViewPromotionEvent, dispatchSelectPromotionEvent } =
  useGAPromotionEvents()

const stripAnchorsList = ref(
  props.contentStrip
    ? props.contentStrip.map(message =>
        message.link.label ? message.link.label : null
      )
    : []
)

onMounted(() => {
  if (stripAnchorsList.value.length > 0) {
    dispatchViewPromotionEvent(stripAnchorsList?.value[0] ?? '', [], true)
  }
})

const handleClick = (item: EditorialStripAnchorsItemProps) => {
  dispatchSelectPromotionEvent(
    'carousel_slider',
    item.link?.target ?? '',
    item.link.label ?? ''
  )
}
</script>

<template>
  <div
    class="bg-background-secondary border-y-neutral-gray lg:py-4xl px-md py-xxl border-y"
    :class="[
      bgColorStrip ? `bg-neutral-${bgColorStrip}` : 'bg-background-secondary',
    ]"
  >
    <ul class="gap-xxl grid grid-cols-2 justify-items-center md:grid-cols-4">
      <li
        v-for="(stripItem, index) in contentStrip"
        :key="`${stripItem.link.label}-${index}`"
        class="flex w-full flex-col"
      >
        <EditorialStripAnchorsItem
          v-bind="stripItem"
          :text-color="textColor"
          :type="type"
          @emit-item="handleClick(stripItem)"
        />
      </li>
    </ul>
  </div>
</template>
